import { createFileRoute } from "@tanstack/react-router";
import { Helmet } from "react-helmet-async";
import { Target, Eye, Heart } from "lucide-react";
import lifestyle from "@/assets/about-lifestyle.jpg";

export const Route = createFileRoute("/about")({
  component: AboutPage,
});

function AboutPage() {
  return (
    <>
      <Helmet>
        <title>About Us</title>
        <meta name="description" content="Trendora Marts is a fast-growing Pakistani e-commerce brand delivering trending, high-quality products nationwide." />
        <meta property="og:title" content="About Trendora Marts" />
      </Helmet>
      <section className="bg-card text-foreground py-20 border-y border-border">
        <div className="container mx-auto px-4 text-center max-w-3xl">
          <p className="text-gold uppercase text-xs tracking-[0.3em] mb-3">Our Story</p>
          <h1 className="text-4xl sm:text-5xl font-serif mb-6">Smart Shopping for Modern Pakistan</h1>
          <p className="text-primary-foreground/80 text-lg leading-relaxed">
            Trendora Marts is a fast-growing e-commerce brand in Pakistan, dedicated to bringing trending, practical, and high-quality products to customers nationwide. With over 2 years of experience, we focus on delivering value, convenience, and customer satisfaction. Our goal is to make online shopping simple, reliable, and enjoyable.
          </p>
        </div>
      </section>

      <section className="container mx-auto px-4 py-20 grid md:grid-cols-2 gap-12 items-center">
        <img src={lifestyle} alt="Happy customers" loading="lazy" className="rounded-lg shadow-elegant w-full h-auto" />
        <div>
          <p className="text-gold uppercase text-xs tracking-[0.3em] mb-3">Why We Exist</p>
          <h2 className="text-3xl sm:text-4xl font-serif mb-6">Bringing Quality Within Reach</h2>
          <p className="text-muted-foreground leading-relaxed mb-4">
            We believe everyone deserves access to premium products without the premium price tag. Every item in our store is hand-picked for quality, usefulness, and value.
          </p>
          <p className="text-muted-foreground leading-relaxed">
            From smart gadgets that make life easier to toys that bring joy to children, we're here to upgrade your everyday.
          </p>
        </div>
      </section>

      <section className="bg-secondary py-20">
        <div className="container mx-auto px-4 grid md:grid-cols-3 gap-6">
          {[
            { i: Target, t: "Our Mission", d: "To deliver premium lifestyle products at affordable prices, making quality accessible to every household in Pakistan." },
            { i: Eye, t: "Our Vision", d: "To become Pakistan's most trusted lifestyle store, known for curation, customer care, and reliable nationwide delivery." },
            { i: Heart, t: "Customer Satisfaction", d: "Every order is a relationship. We back every product with honest support, easy returns, and genuine care." },
          ].map((c) => (
            <div key={c.t} className="bg-card rounded-lg p-8 border border-border hover-lift">
              <div className="h-14 w-14 rounded-full bg-gradient-gold grid place-items-center mb-5">
                <c.i className="h-7 w-7 text-gold-foreground" />
              </div>
              <h3 className="font-serif text-xl mb-3">{c.t}</h3>
              <p className="text-muted-foreground text-sm leading-relaxed">{c.d}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
